/* Greaser's Alley — home hero: pinstripe brush lines that part under the cursor, metal-flake
   glints, a glow and flake mask that follow the pointer, and a little parallax on the artwork.
   Each [data-hero] boots once; the theme editor's section reload boots the new copy. */
(function () {
  'use strict';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const PAL = ['223,18,18', '239,224,180', '223,18,18', '63,182,178', '239,224,180', '223,18,18'];
  const rand = (a, b) => a + Math.random() * (b - a);

  function boot(hero) {
    if (hero.dataset.heroReady) return;
    hero.dataset.heroReady = '1';
    const canvas = hero.querySelector('[data-pinstripe]');
    const art = hero.querySelector('.hero-art');
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let W = 0, H = 0;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    let strands = [], flakes = [];
    const pointer = { x: -9999, y: -9999, tx: -9999, ty: -9999, active: false };
    const glow = { x: .3, y: .45, tx: .3, ty: .45, lastX: -1, lastY: -1 };
    const art3d = { mx: 0, my: 0, sy: 0 };
    const t0 = performance.now();
    let visible = true;

    function buildStrands() {
      const mobile = W < 700, n = mobile ? 8 : 12, pts = mobile ? 26 : 40;
      strands = [];
      for (let i = 0; i < n; i++) {
        strands.push({
          base: .05 + (i + rand(-.3, .3)) / (n - 1) * .9,
          amp: rand(.035, .1), amp2: rand(.01, .035),
          freq: rand(.8, 2), freq2: rand(2.6, 4.2),
          speed: rand(.12, .3) * (Math.random() < .5 ? -1 : 1),
          phase: rand(0, Math.PI * 2),
          col: PAL[i % PAL.length], w: rand(.7, 1.5), a: rand(.3, .62),
          delay: i * .07 + rand(0, .15),
          n: pts, off: new Float32Array(pts), vel: new Float32Array(pts)
        });
      }
    }
    function buildFlakes() {
      flakes = [];
      const m = W < 700 ? 50 : 100;
      for (let j = 0; j < m; j++) flakes.push({ x: rand(0, W), y: rand(0, H), vx: rand(-.12, .12), vy: rand(-.08, .08), r: rand(.5, 1.6), tw: rand(0, 6.28), ts: rand(.8, 2.4), c: Math.random() < .7 ? '239,224,180' : '240,70,50' });
    }

    function resize() {
      const oldW = W, oldH = H;
      W = canvas.offsetWidth; H = canvas.offsetHeight;
      canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      if (flakes.length && oldW && oldH) flakes.forEach(p => { p.x = p.x / oldW * W; p.y = p.y / oldH * H; });
      else if (W && H) buildFlakes();
      // strands live in normalized 0..1 space, so they always span the new size
      if (!strands.length || (oldW < 700) !== (W < 700)) buildStrands();
      if (reduce) draw(performance.now());
    }

    const strandY = (s, u, t) => (s.base + s.amp * Math.sin(u * s.freq * Math.PI * 2 + s.phase + t * s.speed) + s.amp2 * Math.sin(u * s.freq2 * Math.PI * 2 - t * s.speed * 1.7)) * H;

    function draw(now) {
      const t = (now - t0) / 1000;
      ctx.clearRect(0, 0, W, H);
      pointer.x += (pointer.tx - pointer.x) * .18; pointer.y += (pointer.ty - pointer.y) * .18;
      const R = Math.max(150, Math.min(W, H) * .26), px = pointer.x, py = pointer.y;
      ctx.lineCap = 'round'; ctx.lineJoin = 'round';
      for (const s of strands) {
        const n = s.n;
        let prog = reduce ? 1 : Math.max(0, Math.min(1, (t - s.delay) / 1.8));
        prog = 1 - Math.pow(1 - prog, 3);
        const last = Math.max(1, Math.floor((n - 1) * prog)), xs = [], ys = [];
        for (let k = 0; k <= last; k++) {
          const u = k / (n - 1), x = (u * 1.1 - .05) * W, y = strandY(s, u, t);
          // the brush: the cursor parts the stripes, a spring lays them back down
          const dx = x - px, dy = y - py, d = Math.sqrt(dx * dx + dy * dy);
          let target = 0;
          if (d < R) { const f = 1 - d / R; target = (dy >= 0 ? 1 : -1) * f * f * R * .55; }
          s.vel[k] += (target - s.off[k]) * .06; s.vel[k] *= .82; s.off[k] += s.vel[k];
          xs.push(x); ys.push(y + s.off[k]);
        }
        for (let pass = 0; pass < 2; pass++) {
          ctx.beginPath(); ctx.moveTo(xs[0], ys[0]);
          for (let q = 1; q < xs.length - 1; q++) ctx.quadraticCurveTo(xs[q], ys[q], (xs[q] + xs[q + 1]) / 2, (ys[q] + ys[q + 1]) / 2);
          ctx.lineTo(xs[xs.length - 1], ys[ys.length - 1]);
          if (pass === 0) { ctx.strokeStyle = 'rgba(' + s.col + ',' + (s.a * .16) + ')'; ctx.lineWidth = s.w * 6; }
          else { ctx.strokeStyle = 'rgba(' + s.col + ',' + s.a + ')'; ctx.lineWidth = s.w; }
          ctx.stroke();
        }
        if (prog < 1 && !reduce) { // wet paint at the brush tip while the stripe is laid
          ctx.beginPath(); ctx.arc(xs[xs.length - 1], ys[ys.length - 1], 2.4, 0, 6.283);
          ctx.fillStyle = 'rgba(' + s.col + ',.9)'; ctx.fill();
        }
      }
      for (const p of flakes) {
        if (!reduce) {
          const fx = px - p.x, fy = py - p.y, fd = Math.sqrt(fx * fx + fy * fy);
          if (fd < 200 && fd > 1) { p.vx += fx / fd * .02; p.vy += fy / fd * .02; }
          p.vx *= .985; p.vy *= .985; p.x += p.vx; p.y += p.vy;
          if (p.x < -10) p.x = W + 10; else if (p.x > W + 10) p.x = -10;
          if (p.y < -10) p.y = H + 10; else if (p.y > H + 10) p.y = -10;
        }
        const near = Math.max(0, 1 - Math.sqrt((px - p.x) * (px - p.x) + (py - p.y) * (py - p.y)) / 220);
        const al = .22 + .5 * Math.abs(Math.sin(t * p.ts + p.tw));
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r * (1 + near * 1.2), 0, 6.283);
        ctx.fillStyle = 'rgba(' + p.c + ',' + Math.min(1, al + near * .5) + ')'; ctx.fill();
      }
      // glow + flake mask follow the pointer; only write CSS vars when it actually moved
      glow.x += (glow.tx - glow.x) * .12; glow.y += (glow.ty - glow.y) * .12;
      const gx = Math.round(glow.x * W), gy = Math.round(glow.y * H);
      if (Math.abs(gx - glow.lastX) > 1 || Math.abs(gy - glow.lastY) > 1) {
        hero.style.setProperty('--mx', gx + 'px'); hero.style.setProperty('--my', gy + 'px');
        glow.lastX = gx; glow.lastY = gy;
      }
    }

    function loop(now) {
      if (!document.contains(hero)) return; // section was re-rendered in the editor
      if (visible && !document.hidden) draw(now);
      requestAnimationFrame(loop);
    }

    function applyArt() {
      if (!art) return;
      if (W < 700) { art.style.removeProperty('--px'); art.style.removeProperty('--py'); return; }
      art.style.setProperty('--px', art3d.mx + 'px'); art.style.setProperty('--py', (art3d.my + art3d.sy) + 'px');
    }
    function setPointer(cx, cy) {
      const r = hero.getBoundingClientRect(), x = cx - r.left, y = cy - r.top;
      pointer.tx = x; pointer.ty = y;
      if (!pointer.active) { pointer.x = x; pointer.y = y; pointer.active = true; }
      glow.tx = x / r.width; glow.ty = y / r.height;
      if (fine && !reduce) { art3d.mx = (x / r.width - .5) * -14; art3d.my = (y / r.height - .5) * -10; applyArt(); }
    }
    function release() { pointer.tx = -9999; pointer.ty = -9999; pointer.active = false; }
    hero.addEventListener('mousemove', e => setPointer(e.clientX, e.clientY));
    hero.addEventListener('mouseleave', release);
    hero.addEventListener('touchstart', e => { const t = e.touches[0]; setPointer(t.clientX, t.clientY); }, { passive: true });
    hero.addEventListener('touchmove', e => { const t = e.touches[0]; setPointer(t.clientX, t.clientY); }, { passive: true });
    hero.addEventListener('touchend', release, { passive: true });
    window.addEventListener('deviceorientation', e => {
      if (pointer.active || e.gamma == null) return;
      glow.tx = Math.max(.05, Math.min(.95, .5 + e.gamma / 60));
      glow.ty = Math.max(.05, Math.min(.95, .45 + (e.beta - 45) / 90));
    }, { passive: true });
    window.addEventListener('scroll', () => {
      if (reduce) return;
      const y = window.scrollY;
      if (y < H + 200) { art3d.sy = y * .12; applyArt(); }
    }, { passive: true });

    new IntersectionObserver(es => { visible = es[0].isIntersecting; }).observe(hero);
    window.addEventListener('resize', resize);
    window.addEventListener('load', resize);
    resize();
    if (reduce) draw(performance.now()); else requestAnimationFrame(loop);
  }

  const bootAll = root => (root || document).querySelectorAll('[data-hero]').forEach(boot);
  bootAll();
  document.addEventListener('shopify:section:load', e => bootAll(e.target));
})();
